var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"is-size-3 mb-4"},[_vm._v(_vm._s(_vm.data.name))]),_c('div',[_vm._v(_vm._s(_vm.data.address))]),_c('div',[_vm._v("Telp. "+_vm._s(_vm.data.phone))])])}
var staticRenderFns = []

export { render, staticRenderFns }